import {ApiClient} from "../generated/ApiClient";
import {Aborted, useFetcher} from "./useFetcher";
import {
    FrontWebRadioModel,
    type FrontWebSearchResultEpisodesModel,
    GetApiPodcastEpisodesOrderByEnum,
    ResponseError
} from "../generated";

export const useProgramEpisodesKey = (
    page: number,
    slugProgram: string,
    orderBy: GetApiPodcastEpisodesOrderByEnum
    ) => ({
    queryKey: ["useProgramEpisodesKey", slugProgram, orderBy, page],
    queryFn:  useFetcher(slugProgram === 'rozposlouchane' ? () => new ApiClient().getApiPodcastListenedEpisodes({
            page: page,
        }, {
            credentials: "include",
            signal: Aborted().signal
        }).catch(e =>{
            if (e instanceof ResponseError
                && (e.response.status === 401 || e.response.status === 404)) {
                return {
                    pages: -1,
                    count: -1,
                    result: [] as FrontWebRadioModel[]
                }
            }
            throw e;
        }) as Promise<FrontWebSearchResultEpisodesModel> : () => new ApiClient().getApiPodcastEpisodes({
        programSlug: slugProgram,
        page: page,
        orderBy: orderBy
    }, {
        credentials: "include",
        signal: Aborted().signal
    }))
})